import React, { Component } from 'react';
import Parse                from 'parse';
import classNames           from 'classnames/bind';
import Utils                from '../../Utils/Utility';

let wllogo = require('../../../img/wl-logo-blue.png');

export default class RegisterRestaurant extends Component {

    constructor(props){
        super(props);
        this.state = {
            lbName               : '',
            resName              : '',
            resAddress1          : '',
            resAddress2          : '',
            resState             : '',
            resZipCode           : '',
            resCity              : '',
            resPhone             : '',
            resWebsite           : '',
            copyBizFields        : false,
            isLocationAccCreated : false,
            isTempDataSaved      : false
        };
        this._bind(
            'changeLbName'         , 'changeResName',
            'changeResAddress1'    , 'changeResAddress2',
            'changeResState'       , 'changeResZipCode',
            'changeResCity'        , 'changeResPhone',
            'changeResWebsite'     , 'changeCopyBizFields',
            'handleSubmit'         , 'createLocationPromise',
            'saveCustomerTempData' , 'copyResObjectToState'
        );
    }

    _bind(...methods) {
      methods.forEach( (method) => this[method] = this[method].bind(this) );
     }

     //Restaurant fieldsets starts

    changeLbName(e) {
        this.setState({lbName:e.target.value}, () => {
            this.props.updateParentField("lbName", this.state.lbName);
        });
    }

    changeResName(e) {
        this.setState({resName:e.target.value}, () => {
            this.props.updateParentField("resName", this.state.resName);
        });
    }

    changeResAddress1(e) {
        this.setState({resAddress1:e.target.value}, () => {
            this.props.updateParentField("resAddress1", this.state.resAddress1);
        });
    }

    changeResAddress2(e) {
        this.setState({resAddress2:e.target.value}, () => {
            this.props.updateParentField("resAddress2", this.state.resAddress2);
        });
    }

    changeResState(e) {
        this.setState({resState:e.target.value}, () => {
            this.props.updateParentField("resState", this.state.resState);
        });
    }

    changeResZipCode(e) {
        this.setState({resZipCode:e.target.value}, () => {
            this.props.updateParentField("resZipCode", this.state.resZipCode);
        });
    }

    changeResCity(e) {
        this.setState({resCity:e.target.value}, () => {
            this.props.updateParentField("resCity", this.state.resCity);
        });
    }

    changeResPhone(e) {
        this.setState({resPhone:e.target.value}, () => {
            this.props.updateParentField("resPhone", this.state.resPhone);
        });
    }

    changeResWebsite(e) {
        this.setState({resWebsite:e.target.value}, () => {
            this.props.updateParentField("resWebsite", this.state.resWebsite);
        });
    }

    changeCopyBizFields(e) {
        let checkBoxChecked = e.target.checked;

        this.setState({ copyBizFields : checkBoxChecked });

        if (checkBoxChecked) {
            this.props.copyBizToRes();
        } else {
            this.props.resetResFields();
        }

    }

     //Restaurant fieldsets ends

    //Restaurant form submit handler


    createLocationPromise() {
        let LocationDetail = Parse.Object.extend("LocationDetail");
        let locationDetail = new LocationDetail();

        return locationDetail.save({
            lbName      : this.state.lbName,
            name        : this.state.resName,
            addLine1    : this.state.resAddress,
            state       : this.state.resState,
            city        : this.state.resCity,
            zipCode     : this.state.resZipCode,
            phoneNumber : this.state.resPhone,
            url         : this.state.resWebsite
        });
    }

    saveCustomerTempData() {
        let currentUser = Parse.User.current();
        let promise     = new Parse.Promise();

        $.post('/api/saveUser',
        {
            userId : currentUser.id,
            locId  : currentUser.get("locationDetailPointer").id
        },
        function(data, status){
            if(status==="success"){
                promise.resolve(status);
            }else{
                promise.reject("Error in saveUser"+status);
            }
            console.log("Data: " + data + "\nStatus: " + status);
        });
        return promise;
    }

    handleSubmit(e) {

        e.preventDefault();

        this.setState({ showSpinner : true});

        this.createLocationPromise()
        .then((locationDetail) => {
            console.log(JSON.stringify(locationDetail));
            this.setState({
                locationDetail,
                isLocationAccCreated:true
            });
            return locationDetail;
        })
        .then((locationDetail) => {

            let user = Parse.User.current();
            user.set("locationDetailPointer",locationDetail);
            return user.save(null);
        })
        .then((user) => {
            console.log("User locationDetail updated");
            this.setState({user});
            return this.saveCustomerTempData();
        })
        .then((data) => {
            console.log("Finished"+data);
            this.setState({isTempDataSaved:true, showSpinner:false });
        },(error) => {
            console.log("Error in signUp new user:"+error.message);
        });
    }

    copyResObjectToState(resObject) {
        this.setState({

           lbName      : resObject.lbName,
           resName     : resObject.resName,
           resAddress1 : resObject.resAddress1,
           resAddress2 : resObject.resAddress2,
           resState    : resObject.resState,
           resCity     : resObject.resCity,
           resZipCode  : resObject.resZipCode,
           resPhone    : resObject.resPhone,
           resWebsite  : resObject.resWebsite

        });
    }

    componentWillMount() {
        if (this.props.resObject) {
            this.copyResObjectToState(this.props.resObject);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.resObject) {
            this.copyResObjectToState(nextProps.resObject);
        }
    }

    render(){

        let RegisterRestaurantComp = (
                <div className="row">
                    <div className="col-md-12" style={{ marginLeft : 50, marginRight : 50 }}>
                        <br/>
                        <h3>Restaurant Details</h3>
                        <br/>
                        <fieldset>

                              <div className = "form-group">
                                  <div className = "col-xs-12 text-center">
                                      <div className = "checkbox">
                                          <label className="chk-bx-lbl">
                                              <input
                                                  type    = "checkbox"
                                                  id      = "copyBiz"
                                                  ref     = "copyBiz"
                                                  onClick = {this.changeCopyBizFields}
                                                  checked = {this.state.copyBizFields}
                                              />
                                              Restaurant address is same as Business address
                                           </label>
                                       </div>
                                   </div>
                              </div>

                              {/*<!-- Text input-->*/}

                              {/*
                              <div className="form-group">
                                <div className="col-xs-12">
                                    <label htmlFor="lbFName">Legal Business Name</label>
                                    <input id="lbFName" ref="lbName" type="text" placeholder="Legal Business Name"
                                        onChange={this.changeLbName} value = {this.state.lbName} className="form-control" required autoFocus/>
                                </div>
                              </div>

                              <div className="form-group">
                                <div className="col-xs-12">
                                    <label htmlFor="resName">Name</label>
                                    <input id="resName" ref="resName" type="text" placeholder="Restaurant Name"
                                        onChange={this.changeResName} value = {this.state.resName} className="form-control" required autoFocus/>
                                </div>
                              </div>
                              */}

                              <div className="form-group">
                                <div className="col-xs-12">
                                    <label htmlFor="resAdd1">Address Line1</label>

                                    <input
                                        id          = "resAdd1"
                                        ref         = "resAdd1"
                                        type        = "text"
                                        placeholder = "Restaurant Address Line1"
                                        onChange    = {this.changeResAddress1}
                                        value       = {this.state.resAddress1}
                                        className   = "form-control"
                                        required
                                    />
                                    <input
                                        id          = "resAdd2"
                                        ref         = "resAdd2"
                                        type        = "text"
                                        placeholder = "Restaurant Address Line2"
                                        onChange    = {this.changeResAddress2}
                                        value       = {this.state.resAddress2}
                                        className   = "form-control"
                                        style       = {{marginTop:10}}
                                    />
                                </div>
                              </div>

                              <div className="form-group">
                                <div className="col-xs-6">
                                    <label htmlFor="resState">State</label>
                                    <input
                                        id          = "resState"
                                        ref         = "resState"
                                        type        = "text"
                                        placeholder = "State"
                                        onChange    = {this.changeResState}
                                        value       = {this.state.resState}
                                        className   = "form-control"
                                        required
                                    />
                                </div>
                                <div className="col-xs-6">
                                    <label htmlFor="resZipCode">Zip Code</label>
                                    <input
                                        id          = "resZipCode"
                                        ref         = "resZipCode"
                                        type        = "text"
                                        placeholder = "Zip Code"
                                        onChange    = {this.changeResZipCode}
                                        value       = {this.state.resZipCode}
                                        className   = "form-control"
                                        required
                                    />
                                </div>
                              </div>

                              <div className="form-group">
                                <div className="col-xs-12">
                                    <label htmlFor="resCity">City</label>
                                    <input
                                        id          = "resCity"
                                        ref         = "resCity"
                                        type        = "text"
                                        placeholder = "City"
                                        title       = "City"
                                        onChange    = {this.changeResCity}
                                        value       = {this.state.resCity}
                                        className   = "form-control"
                                        required
                                    />
                                </div>
                              </div>

                              <div className="form-group">
                                <div className="col-xs-12">
                                    <label htmlFor="resPhone">Phone</label>
                                    <input
                                        id          = "resPhone"
                                        type        = "tel"
                                        ref         = "resPhone"
                                        placeholder = "phone"
                                        title       = "XXXXXXXXXX"
                                        onChange    = {this.changeResPhone}
                                        value       = {this.state.resPhone}
                                        className   = "form-control"
                                        pattern     = "\d{3}\d{3}\d{4}"
                                        required
                                    />
                                </div>
                              </div>

                              <div className="form-group">
                                <div className="col-xs-12">
                                    <label htmlFor="resWebsite">Website</label>
                                    <input
                                        id          = "resWebsite"
                                        ref         = "resWebsite"
                                        type        = "text"
                                        placeholder = "Website"
                                        title       = "Website"
                                        onChange    = {this.changeResWebsite}
                                        value       = {this.state.resWebsite}
                                        className   = "form-control"
                                        required
                                    />
                                </div>
                              </div>

                          </fieldset>
                      </div>
                    </div>
            );

            return  RegisterRestaurantComp;
    }

}





// WEBPACK FOOTER //
// src/components/register/RegisterRestaurant.js